import classNames from 'classnames';
import { useMemo } from 'react';
import { Button, Heading, List } from 'yoso';
import { T } from '~/components/I18n';
import { useLandEventWinners } from '~/components/Land/Event/Winner/LandEventWinner.hooks';
import { landMeta } from '~/components/Land/Land.meta';
import { InlineList } from '~/components/List/Inline/InlineList';
import { Pair } from '~/components/Pair';
import { Link, LinkProps } from '~/components/Route/Link';
import { format } from '~/components/Util/number';
import styles from './LandEventWinner.module.scss';

export type LandEventWinnerProps = {
  className?: string;
};

export const LandEventWinner = ({ className }: LandEventWinnerProps) => {
  const { data } = useLandEventWinners();
  const winners = useMemo(
    () => data?.pages.map(({ rankingList }) => rankingList).flat() || [],
    [data]
  );

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.header}>
        <Heading level={4} className={styles.title}>
          <T name="citizen_land_winners_title" options={[data?.pages[0].week]} />
        </Heading>
        <Button<LinkProps>
          as={Link}
          to="/support/notice?category=winners"
          color="default"
          size="small"
          data-event="click"
          data-event-target="land_winners_seeall_btn">
          <T name="citizen_button_title_seeall" />
        </Button>
      </div>
      <div className={styles.body}>
        <List className={styles.list}>
          {winners.map(
            ({
              ranking,
              displayName,
              landType,
              zoneNumber,
              profileImageUrl,
              snapshot,
              rewardAmountInFnsa,
              rewardAmountInUsd,
            }) => (
              <li key={ranking}>
                <div className={styles.item}>
                  <div className={styles.left}>
                    <img
                      className={styles.profile}
                      src={profileImageUrl}
                      width={58}
                      height={58}
                      alt={displayName}
                    />
                  </div>
                  <div className={styles.right}>
                    <div className={styles.info}>
                      <p>{displayName}</p>
                      <InlineList className={styles.snapshot} divided>
                        <li>
                          {landMeta[landType].title}, Z{zoneNumber}
                        </li>
                        <li>
                          <span>
                            LUP <strong>{format(snapshot.lup)}</strong>
                          </span>
                          <span>
                            Lv{snapshot.citizenNftLevel}{' '}
                            <strong>{format(snapshot.citizenNftCount)}</strong>
                          </span>
                        </li>
                      </InlineList>
                    </div>
                    <Pair
                      className={styles.pair}
                      primaryPrice={rewardAmountInFnsa}
                      primaryCurrency="FNSA"
                      secondaryPrice={rewardAmountInUsd}
                      secondaryCurrency="USD"
                    />
                  </div>
                </div>
              </li>
            )
          )}
        </List>
      </div>
    </div>
  );
};
